export default "__VITE_ASSET__a7b8bab2__"